/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize myLabsView View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './myLabsView';

export const mapStateToPropsmyLabsViewView = mapStateToProps;
export const mapDispatchToPropsmyLabsViewView = mapDispatchToProps;

export default connect(
  mapStateToPropsmyLabsViewView,
  mapDispatchToPropsmyLabsViewView
)(View);
